import { render, staticRenderFns } from "./DecideAboutExclusion.vue?vue&type=template&id=0acab6ff&lang=pug&"
import script from "./DecideAboutExclusion.vue?vue&type=script&lang=js&"
export * from "./DecideAboutExclusion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports